<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
import { useAnalysisStore } from '@/store/modules/analysis';
import {
  removeAsterisk,
  splitKeywordParts,
  splitBySentence,
  splitSentencesByDivider,
  splitCommaSeparatedWords,
} from '@/composables/splitSentence';
import PersonalitySub20Info from './ContentsPersonality20_info.vue';

const props = defineProps({
  pData: Object,
  userName: String,
  isMobile: Boolean,
});
const store = useAnalysisStore();
// const userName = computed(() => store.userName)
onMounted(() => {
  // pData.value = store.analysisResult;
});

const majorRecoListAll = computed(() => {
  const raw = props.pData?.진로학과?.일반추천분야 || {};
  return Object.entries(raw).map(([key, value]) => ({
    key,
    descriptionSentences: splitBySentence(value.설명),
    majors: value.학과,
  }));
});

const majorRecoList1 = computed(() => majorRecoListAll.value.slice(0, 2));
const majorRecoList2 = computed(() => majorRecoListAll.value.slice(2));
const generalCareerReco = computed(() => splitBySentence(props.pData.진로추천.일반추천));
const generalCRItems = computed(() => props.pData.진로추천.추천분야.일반추천분야);
</script>

<template>
  <VRow class="full-height">
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-first">
      <VCard class="personality-card full-height right">
        <div class="detail-card__top-title personality">
          <!-- <span class="detail-tit__num personality"></span> -->
          <span class="detail-tit__txt personality">또 다른 가능성의 권장 진로</span>
        </div>
        <div class="personality-wrapper">
          <div class="person-desc-box">
            <div class="desc__title">🤔 함께 고려해볼 수 있는 다양한 진로 방향도 제안드려요.</div>
            <div class="desc__body">
              <div class="career__circle-box">
                <div v-for="(item, idx) in generalCRItems" :key="idx" class="career-circle gray">
                  <span class="circle__main-txt">
                    {{ item }}
                  </span>
                </div>
              </div>
              <div v-for="(sentence, idx) in generalCareerReco" :key="idx">
                <span class="content__body-txt">
                  <template v-for="(part, pIdx) in splitKeywordParts(sentence)" :key="pIdx">
                    <span v-if="part.isKeyword" class="p-keyword">{{ part.text }}</span>
                    <template v-else>{{ part.text }}</template>
                  </template>
                </span>
              </div>
            </div>
          </div>
          <section
            v-for="(reco, recoIdx) in majorRecoList1"
            :key="recoIdx"
            class="career__major-reco"
          >
            <div class="major__top general">
              <span class="major__top-title">{{ reco.key }}</span>
              <!-- TODO: 이지- 백엔드에 반환 요청 기획 요청 -->
              <div class="major__top-keyword">
                <span
                  v-for="(major, mIdx) in reco.majors"
                  :key="mIdx"
                  class="major-keyword general"
                >
                  {{ major }}
                </span>
              </div>
            </div>
            <div class="major__bottom">
              <div v-for="(sentence, idx) in reco.descriptionSentences" :key="idx">
                <span class="content__body-txt">
                  <template v-for="(part, pIdx) in splitKeywordParts(sentence)" :key="pIdx">
                    <span v-if="part.isKeyword" class="p-keyword">{{ part.text }}</span>
                    <template v-else>{{ part.text }}</template>
                  </template>
                </span>
              </div>
            </div>
          </section>
        </div>
      </VCard>
    </VCol>
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-second">
      <!-- 3상면 기존 진로 추천 리스트 -->
      <VCard v-if="majorRecoList2.length > 0" class="personality-card full-height">
        <div class="personality-wrapper">
          <section
            v-for="(reco, recoIdx) in majorRecoList2"
            :key="recoIdx"
            class="career__major-reco"
          >
            <div class="major__top general">
              <span class="major__top-title">{{ reco.key }}</span>
              <!-- TODO: 이지- 백엔드에 반환 요청 기획 요청 -->
              <div class="major__top-keyword">
                <span
                  v-for="(major, mIdx) in reco.majors"
                  :key="mIdx"
                  class="major-keyword general"
                >
                  {{ major }}
                </span>
              </div>
            </div>
            <div class="major__bottom">
              <div v-for="(sentence, idx) in reco.descriptionSentences" :key="idx">
                <span class="content__body-txt">
                  <template v-for="(part, pIdx) in splitKeywordParts(sentence)" :key="pIdx">
                    <span v-if="part.isKeyword" class="p-keyword">{{ part.text }}</span>
                    <template v-else>{{ part.text }}</template>
                  </template>
                </span>
              </div>
            </div>
          </section>
        </div>
      </VCard>

      <!-- 3미만면 personalitySub20_info 컴포넌트 시작 -->
      <PersonalitySub20Info v-else />
    </VCol>
  </VRow>
</template>
<style scoped></style>
